<template>
  <div v-if="rows.length" class="table-responsive">
    <table class="table table-sm table-bordered doc-event-types">
      <thead>
        <tr>
          <th>Type</th>
          <th>Rounds</th>
          <th>Riders</th>
          <th>Horses</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.id">
          <td>{{ row.name }}</td>
          <td>{{ row.rounds }}</td>
          <td>{{ row.riders }}</td>
          <td>{{ row.horses }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { roundsText, ridersText, horsesText } from '@/docs/eventTypeDefaults'

// Dynamic doc element: renders from `context.eventTypes` (the event types API list), so the
// table can never drift from the defaults the form really applies. Renders nothing without it.
export default {
  name: 'DocEventTypesTable',
  props: {
    context: { type: Object, default: () => ({}) }
  },
  computed: {
    rows() {
      return (this.context.eventTypes || []).map(type => ({
        id: type.id,
        name: type.name,
        rounds: roundsText(type.defaults || {}),
        riders: ridersText(type.defaults || {}),
        horses: horsesText(type.defaults || {})
      }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Docs/DocEventTypesTable.vue